<template>
  <div class="schoolPicker">
    <exclude-radio
      :schema="schema.financingType"
      :filter="{ options: financingList }"
      @update="
        $emit('update');
        search($schema.selectedSubschool.$model);
      "
    />

    <w-input
      class="mt-3"
      placeholder="Szukaj szkoły..."
      title="Wyszukiwarka szkół"
      type="search"
      :model="$schema.selectedSubschool"
      @input="search"
    />

    <div class="mt-3 pb-4 filters">
      <checkbox-list title="" :schema="schema.names" :filter="{ options }" @update="$emit('update')" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { SchoolFinancing, schoolFinancingTranslation } from '@/enums/schoolFinancing.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/schoolPickerFilters.schema';

import CheckboxList from './CheckboxList';
import ExcludeRadio from './ExcludeRadio';

// @vuese
// Formularz wyboru szkoły
export default {
  components: { ...components, CheckboxList, ExcludeRadio },
  mixins: [formMixin],
  schema,
  props: {
    // schema
    schema: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  },
  data() {
    return {
      SchoolFinancing,
      financingList: {
        include: { text: schoolFinancingTranslation[SchoolFinancing.SUPPORTED], value: SchoolFinancing.SUPPORTED },
        exclude: { text: schoolFinancingTranslation[SchoolFinancing.SUBSIDIZED], value: SchoolFinancing.SUPPORTED }
      },
      options: [],
      model: {}
    };
  },
  mounted() {
    if (!this.schema.financingType.$eq.$model && !this.schema.financingType.$ne.$model) {
      this.schema.financingType.$eq.$setData(SchoolFinancing.SUPPORTED);
    }
    this.search();
  },
  methods: {
    // @vuese
    // Wyszukuje szkoły
    search(search) {
      return this.$store
        .dispatch('structureNode/list', {
          search,
          hasOrder: this.schema.financingType.$eq.$model === SchoolFinancing.SUPPORTED,
          hasParentOrChildren: true,
          count: -1,
          order: 'order',
          desc: false
        })
        .then(result => {
          this.options = result.list.map(school => ({ text: school.name, value: school.name }));
        });
    }
  }
};
</script>

<style>
.schoolPicker .filters {
  -webkit-column-count: 3;
  -moz-column-count: 3;
  column-count: 3;
}
</style>
